// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion-module_accordion__ngPUM","contain":"Accordion-module_contain__fPevL"};